import { memo, useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "./Layout";
import LogoP from "../ui/atoms/LogoP";
import Buttonz from "../ui/atoms/Buttonz";
import "../styles/atoms.scss";

/**
 * Fallback for old /confirm-signup emails. New emails go to pb02 verify → /signup.
 * Immediately send the browser to PocketBase verify (works without SPA API proxy).
 */
const SignupRequestVerify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [hasError, setHasError] = useState(false);
  const [message, setMessage] = useState("Confirming your email…");

  const handleHomeClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const rid = String(searchParams.get("rid") || "").trim();
    const token = String(searchParams.get("token") || "").trim();
    if (!rid || !token) {
      setHasError(true);
      setMessage(
        "This confirmation link is missing information. Request a new signup email."
      );
      return;
    }

    const q = new URLSearchParams({ rid, token });
    window.location.replace(
      `https://pb02.uud.io/signup-request/verify?${q.toString()}`
    );
  }, [searchParams]);

  return (
    <Layout>
      <div className="signup-verify-page">
        <div className="signup-verify-page__inner">
          <LogoP
            logo="logo03"
            hoverLogo="logo03"
            className="signup-verify-page__logo"
            scale="120px"
            to="/"
          />
          <p className="signup-verify-page__message">{message}</p>
          {hasError ? (
            <Buttonz label="Back to home" onClick={handleHomeClick} />
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default memo(SignupRequestVerify);
